module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-age-friendly-communities.json
// module id = 359
// module chunks = 218321619188206